import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: ${(props) => props.width};
  background: transparent;
  color: ${(props) => props.theme.colors.label};
  font-size: 12px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: start;
  margin: ${(props) => props.margin ? props.margin : '15px 15px 15px 0'};
  padding: ${(props) => !props.noPadding && '8px 20px 8px 5px'};
  ${(props) => props.focused && `border-color: ${props.theme.colors.darkblue}`};
  ${(props) => props.height && `height: ${props.height}`};
  ${(props) => props.disabled && `cursor: not-allowed`};

  .inputMasks {
    width: 100%;
    height: ${(props) => props.height || '60px'};
    font-size: 12px;
    margin: 0 15px 10px 0;
    color: ${(props) => props.theme.colors.darkerblue};
    border-radius: 10px;
    margin-top: 0.6vh;
    padding-top: 1.0vh;
    padding: 10px;
    ::placeholder {
      color: ${(props) => props.alert && props.error ? props.theme.colors.red : props.theme.colors.label};
    }
    :disabled {
      cursor: default;
      opacity: 0.5;
    }
    background: ${(props) => props.theme.colors.card};
    outline: 1px solid ${(props) => props.alert && props.error ? props.theme.colors.red : props.theme.colors.disabled};
    transition: outline-color ${(props) => props.theme.transitions.fast};
    :focus {
      outline: 2px solid ${(props) => props.theme.colors.focus};
    }
  }
`;

export const Icon = styled.img`
  width: ${(props) => (props.size ? props.size : '30px')};
  height: ${(props) => (props.size ? props.size : '30px')};
  margin: 15px;
  cursor: pointer;
`;

export const TitleForm = styled.span`
  color: ${(props) => props.theme.colors.darkerblue};
  font-size: 17px;
  line-height: 27px;

  @media (max-width: 850px) {
    width: 260px;
  }
`;
